(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-submission-form"] && !Shopify.designMode) return;
  try {
    

(function(){
  function init(root){
    if (root.__asfInit) return;
    root.__asfInit = true;

    
    var ta = root.querySelector('[data-asf-contador]');
    var num = root.querySelector('[data-asf-contador-num]');
    if (ta && num){
      var upd = function(){ num.textContent = ta.value.length; };
      ta.addEventListener('input', upd);
      upd();
    }

    
    var addBtn = root.querySelector('[data-asf-add-link]');
    var lista = root.querySelector('[data-asf-feat-lista]');
    if (addBtn && lista){
      addBtn.addEventListener('click', function(){
        
        var tope = parseInt(addBtn.getAttribute('data-asf-max'), 10) || 5;
        if (lista.querySelectorAll('.asf__feat-input').length >= tope) return;
        var row = document.createElement('div');
        row.className = 'asf__feat-row';

        var input = document.createElement('input');
        input.className = 'asf__input asf__feat-input';
        input.type = 'text';
        input.setAttribute('inputmode', 'url');
        input.name = addBtn.getAttribute('data-asf-name');
        input.placeholder = addBtn.getAttribute('data-asf-placeholder') || 'https://';

        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'asf__feat-remove';
        rm.setAttribute('aria-label', addBtn.getAttribute('data-asf-quitar') || 'Remove link');
        rm.innerHTML = '&times;';
        rm.addEventListener('click', function(){ row.remove(); revisarMaximo(); addBtn.focus(); });

        row.appendChild(input);
        row.appendChild(rm);
        lista.appendChild(row);
        revisarMaximo();
        input.focus();
      });
    }

    
    function revisarMaximo(){
      if (!addBtn || !lista) return;
      var max = parseInt(addBtn.getAttribute('data-asf-max'), 10) || 5;
      addBtn.hidden = lista.querySelectorAll('.asf__feat-input').length >= max;
    }
    
    revisarMaximo();

    
    var form = root.querySelector('[data-asf-form]');
    var okBox = root.querySelector('[data-asf-exito]');
    var errBox = root.querySelector('[data-asf-error]');
    if (form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if (okBox) okBox.hidden = true;
        if (errBox) errBox.hidden = true;

        var btn = form.querySelector('.asf__boton');
        var btnLabel = btn ? btn.querySelector('span') : null;
        var original = btnLabel ? btnLabel.textContent : '';
        if (btn){ btn.disabled = true; }
        if (btnLabel){ btnLabel.textContent = form.getAttribute('data-asf-enviando') || 'Sending…'; }

        var data = new FormData(form);

        fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        })
        .then(function(r){ return r.json(); })
        .then(function(json){
          if (json.success){
            
            var campoCorreo = form.querySelector('input[type="email"]');
            var correo = campoCorreo ? campoCorreo.value.trim() : '';
            form.reset();
            
            if (num) num.textContent = '0';
            
            root.querySelectorAll('.asf__feat-row').forEach(function(el){ el.remove(); });
            revisarMaximo();
            if (okBox){
              var texto = okBox.querySelector('[data-asf-exito-texto]');
              var plantilla = texto ? (texto.getAttribute('data-plantilla') || '') : '';
              if (texto && plantilla.indexOf('[email]') !== -1 && correo){
                var partes = plantilla.split('[email]');
                texto.textContent = '';
                texto.appendChild(document.createTextNode(partes[0]));
                var fuerte = document.createElement('strong');
                fuerte.textContent = correo;
                texto.appendChild(fuerte);
                texto.appendChild(document.createTextNode(partes.slice(1).join(correo)));
              }
              
              form.hidden = true;
              okBox.hidden = false;
              okBox.focus({ preventScroll: true });
              
              var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              okBox.scrollIntoView({ behavior: reducido ? 'instant' : 'smooth', block: 'start' });
            }
          } else {
            if (errBox){ errBox.hidden = false; errBox.scrollIntoView({behavior:'smooth', block:'center'}); }
          }
        })
        .catch(function(){
          if (errBox){ errBox.hidden = false; errBox.scrollIntoView({behavior:'smooth', block:'center'}); }
        })
        .finally(function(){
          if (btn){ btn.disabled = false; }
          if (btnLabel){ btnLabel.textContent = original; }
        });
      });
    }
  }

  function boot(){
    document.querySelectorAll('[data-asf-root]').forEach(init);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-announcement-bar-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMarquee(root) {
    if (!root || root.dataset.vyInit === 'true') return;
    root.dataset.vyInit = 'true';

    function applyDirection() {
      var dir = root.getAttribute('data-direction') || 'left';
      root.style.setProperty('--vy-anim-direction', dir === 'right' ? 'reverse' : 'normal');
    }
    applyDirection();

    root.addEventListener('mouseenter', function () { root.setAttribute('data-paused', 'true'); });
    root.addEventListener('mouseleave', function () { root.setAttribute('data-paused', 'false'); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          root.setAttribute('data-offviewport', e.isIntersecting ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(root);
      root.__vyIO = io;
    }
  }

  function destroyMarquee(root) {
    if (root && root.__vyIO) { root.__vyIO.disconnect(); root.__vyIO = null; }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.vy-marquee').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load',     function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload',   function (e) {
    e.target.querySelectorAll('.vy-marquee').forEach(destroyMarquee);
  });
  document.addEventListener('shopify:section:select',   function (e) {
    var node = e.target.querySelector('.vy-marquee');
    if (node) node.setAttribute('data-paused', 'true');
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var node = e.target.querySelector('.vy-marquee');
    if (node) node.setAttribute('data-paused', 'false');
  });
})();
  (function () {
    var CAMPO = '.veery-footer-editorial__news-input';
    document.addEventListener('click', function (ev) {
      var boton = ev.target.closest ? ev.target.closest('[data-vym-newsletter]') : null;
      if (!boton) return;
      var campo = document.querySelector(CAMPO);
      if (!campo) return;
      ev.preventDefault();
      campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var enfocado = false;
      var poner = function () {
        if (enfocado) return;
        enfocado = true;
        campo.focus({ preventScroll: true });
      };
      window.setTimeout(poner, 700);
      var ultimo = -1, quietos = 0, tope = 0;
      (function espera() {
        var y = Math.round(window.scrollY);
        if (y === ultimo) { quietos++; } else { quietos = 0; ultimo = y; }
        tope++;
        if (quietos >= 2 || tope > 72) { poner(); return; }
        requestAnimationFrame(espera);
      })();
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-header-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var instancias = new WeakMap();

    function initHeaderVeery(header) {
      if (!header) return function () {};
      if (instancias.has(header)) return instancias.get(header);

      var ac = new AbortController();
      var signal = ac.signal;


      var fullBleed = header.querySelector('.hv__full-bleed');


      function initMobileMenu() {
        var toggle = header.querySelector('[data-hv-toggle]');
        var menu = header.querySelector('[data-hv-mobile]');
        var scrim = header.querySelector('[data-hv-scrim]');
        if (!toggle || !menu) return;

        var pantallas = menu.querySelectorAll('[data-nav-pantalla]');

        var pila = ['n1'];

        var cerrarDrawerTimeout = null;
        var tecladoReciente = false;

        var estadoFondo = [];
        var estadoBody = null;

        function posicionarMenu() {
          if (!fullBleed) return;
          var rect = fullBleed.getBoundingClientRect();
          var top = Math.max(0, Math.round(rect.bottom) - 1);
          header.style.setProperty('--hv-mobile-menu-top', top + 'px');
          header.style.setProperty('--hv-altura-barra', Math.round(rect.height) + 'px');
        }


        function getPantalla(id) {
          for (var i = 0; i < pantallas.length; i++) {
            if (pantallas[i].getAttribute('data-nav-pantalla') === id) {
              return pantallas[i];
            }
          }
          return null;
        }

        function aplicarPosicion(haciaAtras, sinReinicio) {
          var activaId = pila[pila.length - 1];
          for (var i = 0; i < pantallas.length; i++) {
            var p = pantallas[i];
            var id = p.getAttribute('data-nav-pantalla');
            p.classList.remove('hv__pantalla--atras');
            if (id === activaId) {
              p.hidden = false;
              p.removeAttribute('aria-hidden');
              if (haciaAtras) { p.classList.add('hv__pantalla--atras'); }
              if (!sinReinicio) {
                p.classList.remove('is-activa');
                void p.offsetWidth;
              }
              p.classList.add('is-activa');
            } else {
              p.classList.remove('is-activa');
              p.hidden = true;
              p.setAttribute('aria-hidden', 'true');
            }
          }
        }

        function irA(id) {
          var destino = getPantalla(id);
          if (!destino) return;
          cerrarAcordeones();
          pila.push(id);
          aplicarPosicion(false);
          var titulo = destino.querySelector('.hv__pantalla-titulo');
          if (titulo) {
            requestAnimationFrame(function () { titulo.focus(); });
          }
        }

        function volver() {
          if (pila.length <= 1) return;
          cerrarAcordeones();
          pila.pop();
          aplicarPosicion(true);
          var activaId = pila[pila.length - 1];
          var activa = getPantalla(activaId);
          if (activa) {
            var t = activa.querySelector('.hv__pantalla-titulo');
            if (t) { requestAnimationFrame(function () { t.focus(); }); }
          }
        }

        function cerrarAcordeones() {
          var accAbiertos = menu.querySelectorAll('.hv__seccion-item.is-abierto');
          for (var a = 0; a < accAbiertos.length; a++) {
            accAbiertos[a].classList.remove('is-abierto');
            var btnA = accAbiertos[a].querySelector('[data-acordeon-toggle]');
            if (btnA) btnA.setAttribute('aria-expanded', 'false');
            sincronizarAcordeonInert(accAbiertos[a], false);
          }
        }

        function resetNav() {
          pila = ['n1'];
          cerrarAcordeones();
          for (var i = 0; i < pantallas.length; i++) {
            pantallas[i].style.transition = 'none';
          }
          aplicarPosicion();
          if (pantallas.length) { void pantallas[0].offsetWidth; }
          for (var j = 0; j < pantallas.length; j++) {
            pantallas[j].style.transition = '';
          }
        }

        function sincronizarAcordeonInert(li, abierto) {
          if (!li) return;
          var panel = li.querySelector('[data-acordeon-panel]');
          if (!panel) return;
          if (abierto) {
            panel.removeAttribute('inert');
          } else {
            panel.setAttribute('inert', '');
          }
        }

        function initAcordeonesInert() {
          var items = menu.querySelectorAll('.hv__seccion-item');
          for (var i = 0; i < items.length; i++) {
            var abierto = items[i].classList.contains('is-abierto');
            sincronizarAcordeonInert(items[i], abierto);
          }
        }


        function setFondoInert(activo) {
          if (activo) {
            estadoFondo = [];
            var nodos = document.body ? document.body.children : [];
            for (var i = 0; i < nodos.length; i++) {
              var n = nodos[i];
              if (n.contains(menu)) continue;
              estadoFondo.push({
                nodo: n,
                teniaInert: n.hasAttribute('inert'),
                teniaAriaHidden: n.hasAttribute('aria-hidden'),
                ariaHiddenPrev: n.getAttribute('aria-hidden')
              });
              n.setAttribute('inert', '');
              n.setAttribute('aria-hidden', 'true');
            }
          } else {
            for (var j = 0; j < estadoFondo.length; j++) {
              var e = estadoFondo[j];
              if (e.teniaInert) { e.nodo.setAttribute('inert', ''); }
              else { e.nodo.removeAttribute('inert'); }
              if (e.teniaAriaHidden) { e.nodo.setAttribute('aria-hidden', e.ariaHiddenPrev); }
              else { e.nodo.removeAttribute('aria-hidden'); }
            }
            estadoFondo = [];
          }
        }

        function focoEnfocables() {
          var sel = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
          var todos = menu.querySelectorAll(sel);
          var visibles = [];
          for (var i = 0; i < todos.length; i++) {
            var el = todos[i];
            if (el.closest('[aria-hidden="true"]')) continue;
            if (el.closest('[inert]')) continue;
            if (el.offsetParent !== null || el === document.activeElement) {
              visibles.push(el);
            }
          }
          return visibles;
        }
        function onTrapKeydown(e) {
          if (e.key !== 'Tab') return;
          var f = focoEnfocables();
          if (!f.length) return;
          var primero = f[0];
          var ultimo = f[f.length - 1];
          if (e.shiftKey && document.activeElement === primero) {
            e.preventDefault();
            ultimo.focus();
          } else if (!e.shiftKey && document.activeElement === ultimo) {
            e.preventDefault();
            primero.focus();
          }
        }

        function asegurarN2() {
          if (menu.querySelector('[data-nav-pantalla^="n2-"]')) return;
          var track = menu.querySelector('[data-hv-nav-track]');
          if (!track) return;
          var atras = menu.getAttribute('data-hv-atras') || 'Back';
          var crear = function (tag, clase, attrs) {
            var el = document.createElement(tag);
            if (clase) el.className = clase;
            if (attrs) { for (var k in attrs) { el.setAttribute(k, attrs[k]); } }
            return el;
          };
          var mas = function () {
            var s = crear('span', 'hv__mas', { 'aria-hidden': 'true' });
            s.appendChild(crear('span', 'hv__mas-linea hv__mas-linea--h'));
            s.appendChild(crear('span', 'hv__mas-linea hv__mas-linea--v'));
            return s;
          };
          var botones = menu.querySelectorAll('[data-nav-ir^="n2-"]');
          for (var b = 0; b < botones.length; b++) {
            var destino = botones[b].getAttribute('data-nav-ir');
            var panel = header.querySelector('[data-mega-panel="' + destino.slice(3) + '"]');
            if (!panel) continue;
            var titulo = botones[b].getAttribute('aria-label') || botones[b].textContent.trim();
            var sec = crear('section', 'hv__pantalla hv__pantalla--n2', { 'data-nav-pantalla': destino, 'aria-label': titulo });
            sec.hidden = true;
            var cab = crear('div', 'hv__pantalla-head');
            var btnAtras = crear('button', 'hv__atras', { type: 'button', 'data-nav-atras': '', 'aria-label': atras });
            btnAtras.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M15 5L8 12L15 19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            var tit = crear('span', 'hv__pantalla-titulo', { tabindex: '-1' });
            tit.textContent = titulo;
            cab.appendChild(btnAtras);
            cab.appendChild(tit);
            sec.appendChild(cab);
            var lista = crear('ul', 'hv__seccion-lista', { role: 'list' });
            var cols = panel.querySelectorAll('.mega-fijo__col');
            for (var c = 0; c < cols.length; c++) {
              var col = cols[c];
              var idAcc = 'acc-' + (col.getAttribute('data-col-id') || (destino + '-' + c));
              var flags = col.getAttribute('data-col-flags') || '';
              var puntos = flags.indexOf('p') !== -1;
              var iconos = flags.indexOf('i') !== -1;
              var rejilla = flags.indexOf('g') !== -1;
              var tCol = col.querySelector('.mega-fijo__titulo');
              var tituloCol = tCol ? tCol.textContent.trim() : '';
              var li = crear('li', 'hv__seccion-item');
              var btn = crear('button', 'hv__seccion', { type: 'button', 'data-acordeon-toggle': idAcc, 'aria-expanded': 'false', 'aria-controls': idAcc, 'aria-label': tituloCol });
              var bt = crear('span', 'hv__seccion-titulo');
              bt.textContent = tituloCol;
              btn.appendChild(bt);
              btn.appendChild(mas());
              var pan = crear('div', 'hv__acordeon-panel', { id: idAcc, 'data-acordeon-panel': '' });
              var clases = 'hv__opcion-lista' + (puntos || iconos || rejilla ? ' hv__opcion-lista--colores' : '') + (puntos ? ' hv__opcion-lista--puntos' : '');
              var ul = crear('ul', clases, { role: 'list' });
              var items = col.querySelectorAll('.mega-fijo__lista > li');
              for (var k = 0; k < items.length; k++) {
                var orig = items[k].querySelector('a');
                if (!orig) continue;
                var oli = crear('li', 'hv__opcion-item', { style: '--hvi: ' + (k + 1) + ';' });
                var a = crear('a', 'hv__opcion');
                if (orig.hasAttribute('href')) a.setAttribute('href', orig.getAttribute('href'));
                var thumb = items[k].getAttribute('data-thumb');
                if (thumb) {
                  var th = crear('span', 'hv__opcion-thumb', { 'aria-hidden': 'true' });
                  var ratio = parseFloat(items[k].getAttribute('data-thumb-ratio')) || 1;
                  th.appendChild(crear('img', null, { src: thumb, alt: '', loading: 'lazy', width: '120', height: String(Math.round(120 / ratio)), sizes: '44px' }));
                  a.appendChild(th);
                } else if (puntos) {
                  var p = orig.querySelector('.mega-fijo__punto');
                  if (p) a.appendChild(p.cloneNode(true));
                } else if (iconos) {
                  var ic = orig.querySelector('.mega-fijo__icono');
                  if (ic) {
                    var sp = crear('span', 'hv__opcion-icono mega-fijo__icono', { 'aria-hidden': 'true' });
                    sp.innerHTML = ic.innerHTML;
                    a.appendChild(sp);
                  }
                }
                var spans = orig.querySelectorAll(':scope > span:not([aria-hidden])');
                var ot = crear('span', 'hv__opcion-titulo');
                ot.textContent = (spans.length ? spans[spans.length - 1].textContent : orig.textContent).trim();
                a.appendChild(ot);
                oli.appendChild(a);
                ul.appendChild(oli);
              }
              pan.appendChild(ul);
              li.appendChild(btn);
              li.appendChild(pan);
              lista.appendChild(li);
            }
            sec.appendChild(lista);
            track.appendChild(sec);
          }
          pantallas = menu.querySelectorAll('[data-nav-pantalla]');
          initAcordeonesInert();
        }

        function abrir() {
          asegurarN2();
          if (cerrarDrawerTimeout) {
            clearTimeout(cerrarDrawerTimeout);
            cerrarDrawerTimeout = null;
          }
          posicionarMenu();
          menu.hidden = false;
          if (scrim) scrim.hidden = false;
          requestAnimationFrame(function () {
            header.classList.add('hv-menu-abierto');
            requestAnimationFrame(posicionarMenu);
          });
          toggle.setAttribute('aria-expanded', 'true');

          estadoBody = {
            overflowHtml: document.documentElement.style.overflow,
            paddingRightBody: document.body.style.paddingRight
          };
          var sbw = window.innerWidth - document.documentElement.clientWidth;
          if (sbw > 0) {
            document.documentElement.style.setProperty('--hv-sbw', sbw + 'px');
            document.body.style.paddingRight = sbw + 'px';
          }
          document.documentElement.style.overflow = 'hidden';

          setFondoInert(true);
          menu.addEventListener('keydown', onTrapKeydown, { signal: signal });
        }

        function cerrar() {
          header.classList.remove('hv-menu-abierto');
          toggle.setAttribute('aria-expanded', 'false');
          if (estadoBody) {
            document.documentElement.style.overflow = estadoBody.overflowHtml;
            document.body.style.paddingRight = estadoBody.paddingRightBody;
            estadoBody = null;
          } else {
            document.documentElement.style.overflow = '';
            document.body.style.paddingRight = '';
          }
          menu.removeEventListener('keydown', onTrapKeydown);
          setFondoInert(false);
          if (toggle) {
            try {
              if (tecladoReciente) {
                toggle.focus();
              } else {
                toggle.setAttribute('data-hv-foco-toque', '');
                toggle.focus({ preventScroll: true, focusVisible: false });
              }
            } catch (e) {}
          }
          var onEnd = function () {
            cerrarDrawerTimeout = null;
            menu.hidden = true;
            if (scrim) scrim.hidden = true;
            resetNav();
            header.dispatchEvent(new CustomEvent('hv:menu-cerrado'));
          };
          cerrarDrawerTimeout = setTimeout(onEnd, 280);
        }

        function alternar() {
          if (toggle.getAttribute('aria-expanded') === 'true') {
            cerrar();
          } else {
            abrir();
          }
        }

        document.addEventListener('keydown', function () { tecladoReciente = true; }, { capture: true, signal: signal });
        document.addEventListener('pointerdown', function () { tecladoReciente = false; }, { capture: true, signal: signal });
        var quitarMarcaToque = function () { toggle.removeAttribute('data-hv-foco-toque'); };
        toggle.addEventListener('blur', quitarMarcaToque, { signal: signal });
        toggle.addEventListener('keydown', quitarMarcaToque, { signal: signal });
        toggle.addEventListener('click', alternar, { signal: signal });
        if (scrim) scrim.addEventListener('click', cerrar, { signal: signal });

        menu.addEventListener('click', function (e) {
          var accBtn = e.target.closest('[data-acordeon-toggle]');
          if (accBtn && menu.contains(accBtn)) {
            e.preventDefault();
            var accLi = accBtn.closest('.hv__seccion-item');
            if (!accLi) return;
            var estaAbierto = accLi.classList.contains('is-abierto');
            var todas = menu.querySelectorAll('.hv__seccion-item.is-abierto');
            for (var i = 0; i < todas.length; i++) {
              todas[i].classList.remove('is-abierto');
              var btnPrev = todas[i].querySelector('[data-acordeon-toggle]');
              if (btnPrev) btnPrev.setAttribute('aria-expanded', 'false');
              sincronizarAcordeonInert(todas[i], false);
            }
            if (!estaAbierto) {
              accLi.classList.add('is-abierto');
              accBtn.setAttribute('aria-expanded', 'true');
              sincronizarAcordeonInert(accLi, true);
            }
            return;
          }

          var irBtn = e.target.closest('[data-nav-ir]');
          if (irBtn && menu.contains(irBtn)) {
            e.preventDefault();
            irA(irBtn.getAttribute('data-nav-ir'));
            return;
          }
          var atrasBtn = e.target.closest('[data-nav-atras]');
          if (atrasBtn && menu.contains(atrasBtn)) {
            e.preventDefault();
            volver();
          }
        }, { signal: signal });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
            if (pila.length > 1) {
              volver();
            } else {
              cerrar();
            }
          }
        }, { signal: signal });

        var menuEnEscritorio = window.matchMedia('(min-width: 990px)');
        window.addEventListener('resize', function () {
          if (menuEnEscritorio.matches && toggle.getAttribute('aria-expanded') === 'true') {
            cerrar();
          }
          if (toggle.getAttribute('aria-expanded') === 'true') {
            posicionarMenu();
          }
        }, { signal: signal });

        aplicarPosicion(false, true);
        initAcordeonesInert();
      }

      function initMegaDesktop() {
        var triggers = header.querySelectorAll('[data-mega-trigger]');
        if (!triggers.length) return;

        var cerrarTimeout = null;

        function cerrarTodos() {
          header.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
            panel.classList.remove('is-open');
            panel.hidden = true;
            var id = panel.getAttribute('data-mega-panel');
            var t = header.querySelector('[data-mega-trigger="' + id + '"]');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
        }

        function encajarPanel(panel) {
          var caja = panel.querySelector('.hv__mega-contenedor') || panel;
          panel.style.setProperty('--hv-mega-shift', '0px');
          var zona = header.querySelector('.hv__contenedor');
          var margen = zona ? parseFloat(getComputedStyle(zona).paddingLeft) || 0 : 0;
          var falta = Math.ceil(margen - caja.getBoundingClientRect().left);
          if (falta > 0) panel.style.setProperty('--hv-mega-shift', falta + 'px');
        }

        function abrirPanel(id) {
          if (cerrarTimeout) { clearTimeout(cerrarTimeout); cerrarTimeout = null; }
          try {
            var loc = header.querySelector('dropdown-localization-component.hv__locale');
            if (loc && typeof loc.hidePanel === 'function') loc.hidePanel();
          } catch (e) {  }
          header.querySelectorAll('[data-mega-panel]').forEach(function (panel) {
            var pid = panel.getAttribute('data-mega-panel');
            var t = header.querySelector('[data-mega-trigger="' + pid + '"]');
            if (pid === id) {
              panel.hidden = false;
              encajarPanel(panel);
              requestAnimationFrame(function () { panel.classList.add('is-open'); });
              if (t) t.setAttribute('aria-expanded', 'true');
            } else {
              panel.classList.remove('is-open');
              panel.hidden = true;
              if (t) t.setAttribute('aria-expanded', 'false');
            }
          });
        }

        function programarCierre() {
          if (cerrarTimeout) clearTimeout(cerrarTimeout);
          cerrarTimeout = setTimeout(cerrarTodos, 300);
        }

        function cancelarCierre() {
          if (cerrarTimeout) { clearTimeout(cerrarTimeout); cerrarTimeout = null; }
        }

        function programarCierreSiFueraFoco() {
          requestAnimationFrame(function () {
            var activo = document.activeElement;
            if (!activo) { cerrarTodos(); return; }
            if (activo.closest('[data-mega-item]') || activo.closest('[data-mega-panel]')) {
              return;
            }
            cerrarTodos();
          });
        }

        triggers.forEach(function (trigger) {
          var id = trigger.getAttribute('data-mega-trigger');
          var item = trigger.closest('[data-mega-item]');
          var panel = header.querySelector('[data-mega-panel="' + id + '"]');
          if (!item || !panel) return;

          item.addEventListener('mouseenter', function () { abrirPanel(id); }, { signal: signal });
          panel.addEventListener('mouseenter', cancelarCierre, { signal: signal });
          panel.addEventListener('mouseleave', programarCierre, { signal: signal });

          trigger.addEventListener('focus', function () { abrirPanel(id); }, { signal: signal });
          trigger.addEventListener('blur', programarCierreSiFueraFoco, { signal: signal });
          panel.addEventListener('focusout', programarCierreSiFueraFoco, { signal: signal });
        });

        window.addEventListener('resize', function () {
          var abierto = header.querySelector('[data-mega-panel]:not([hidden])');
          if (abierto) encajarPanel(abierto);
        }, { signal: signal });

        var navDesktop = header.querySelector('.hv__nav-desktop');
        if (navDesktop) {
          navDesktop.addEventListener('mouseenter', cancelarCierre, { signal: signal });
          navDesktop.addEventListener('mouseleave', programarCierre, { signal: signal });
        }

        header.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape') return;
          var abierto = header.querySelector('[data-mega-panel].is-open');
          if (!abierto) return;
          var id = abierto.getAttribute('data-mega-panel');
          var trig = header.querySelector('[data-mega-trigger="' + id + '"]');
          cerrarTodos();
          if (trig) { try { trig.focus(); } catch (err) {} }
        }, { signal: signal });

        document.addEventListener('click', function (e) {
          if (!header.contains(e.target)) cerrarTodos();
        }, { signal: signal });
      }

      initMobileMenu();
      initMegaDesktop();

      function destroy() {
        ac.abort();
        instancias.delete(header);
      }

      instancias.set(header, destroy);
      return destroy;
    }

    function initTodas(scope) {
      var raiz = scope || document;
      raiz.querySelectorAll('[data-header-veery]').forEach(function (header) {
        initHeaderVeery(header);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initTodas(); });
    } else {
      initTodas();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var cont = e.target;
      if (!cont) return;
      var header = cont.querySelector ? cont.querySelector('[data-header-veery]') : null;
      if (header) {
        initHeaderVeery(header);
      } else {
        initTodas(cont);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var cont = e.target;
      if (!cont || !cont.querySelector) return;
      var header = cont.querySelector('[data-header-veery]');
      if (header) {
        var destroy = instancias.get(header);
        if (destroy) destroy();
      }
    });
  })();

  (function () {
    try {
      if (window.__veeryCuentaTop) return;
      window.__veeryCuentaTop = true;

      var SOLAPE = 20;

      var rafPend = false;
      var escritorio = window.matchMedia('(min-width: 990px)');

      function publicar() {
        rafPend = false;
        if (!escritorio.matches) return;
        try {
          var header = document.querySelector('.header-veery');
          if (!header) return;
          var barra = header.querySelector('.hv__full-bleed') || header;
          var base = Math.round(barra.getBoundingClientRect().bottom) - SOLAPE;
          if (base < 0) base = 0;
          var valor = base + 'px';
          var cuentas = header.querySelectorAll('shopify-account');
          for (var i = 0; i < cuentas.length; i++) {
            if (cuentas[i].style.getPropertyValue('--hv-cuenta-top') !== valor) {
              cuentas[i].style.setProperty('--hv-cuenta-top', valor);
            }
          }
        } catch (e) {  }
      }

      function programar() {
        if (rafPend || !escritorio.matches) return;
        rafPend = true;
        requestAnimationFrame(publicar);
      }

      var tResize;
      window.addEventListener('scroll', programar, { passive: true });
      window.addEventListener('resize', function () {
        clearTimeout(tResize);
        tResize = setTimeout(publicar, 150);
      });
      window.addEventListener('orientationchange', function () {
        setTimeout(publicar, 200);
      });
      document.addEventListener(
        'pointerdown',
        function (e) {
          if (e.target && e.target.closest && e.target.closest('.hv__icono-link--cuenta')) publicar();
        },
        true
      );

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', publicar);
      } else {
        publicar();
      }
      window.addEventListener('load', publicar);
    } catch (e) {  }
  })();

  (function () {
    try {
      if (window.__veeryBusquedaSinSalto) return;
      window.__veeryBusquedaSinSalto = true;

      var movil = window.matchMedia('(max-width: 749px)');
      var raiz = document.documentElement;
      var bloqueado = false;

      function alAbrir() {
        var body = document.body;
        if (!movil.matches || body.style.position !== 'fixed') return;
        var y = -parseInt(body.style.top || '0', 10) || 0;
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        raiz.style.overflow = 'hidden';
        window.scrollTo({ top: y, behavior: 'instant' });
        bloqueado = true;
      }

      function alCerrar() {
        if (!bloqueado) return;
        bloqueado = false;
        raiz.style.overflow = '';
      }

      function enganchar() {
        var modal = document.getElementById('search-modal');
        if (!modal || modal.__veerySinSalto) return;
        modal.__veerySinSalto = true;
        modal.addEventListener('dialog:open', alAbrir);
        modal.addEventListener('dialog:close', alCerrar);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', enganchar);
      } else {
        enganchar();
      }
    } catch (e) {  }
  })();

  (function () {
    try {
      if (window.__veeryCarritoSinSalto) return;
      window.__veeryCarritoSinSalto = true;

      var raiz = document.documentElement;
      var bloqueado = false;

      function lenisActual() {
        var vs = window.VeerySmooth;
        return vs && vs.instance ? vs.instance : null;
      }

      function alAbrir() {
        var body = document.body;
        if (body.style.position !== 'fixed') return;
        var y = -parseInt(body.style.top || '0', 10) || 0;
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        raiz.style.scrollbarGutter = 'stable';
        raiz.style.overflow = 'hidden';
        window.scrollTo({ top: y, behavior: 'instant' });
        var l = lenisActual();
        if (l && typeof l.stop === 'function') l.stop();
        bloqueado = true;
      }

      function alCerrar() {
        if (!bloqueado) return;
        bloqueado = false;
        raiz.style.overflow = '';
        raiz.style.scrollbarGutter = '';
        var l = lenisActual();
        if (l && typeof l.start === 'function') l.start();
      }

      function enganchar() {
        var cajon = document.getElementById('hv-cart-drawer');
        if (!cajon || cajon.__veerySinSalto) return;
        cajon.__veerySinSalto = true;
        cajon.addEventListener('dialog:open', alAbrir);
        cajon.addEventListener('dialog:close', alCerrar);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', enganchar);
      } else {
        enganchar();
      }
    } catch (e) {  }
  })();

  window.__veeryTrasCerrarMenu = window.__veeryTrasCerrarMenu || function (fn) {
    var header = document.querySelector('.header-veery');
    if (!header || !header.classList.contains('hv-menu-abierto')) { fn(); return; }
    var hecho = false;
    var una = function () {
      if (hecho) return;
      hecho = true;
      header.removeEventListener('hv:menu-cerrado', una);
      fn();
    };
    header.addEventListener('hv:menu-cerrado', una);
    setTimeout(una, 1500);
    var toggle = header.querySelector('[aria-controls][aria-expanded="true"]');
    if (toggle) toggle.click();
  };

  (function () {
    try {
      if (window.__veeryCuentaMovil) return;
      window.__veeryCuentaMovil = true;

      function triggerCuenta() {
        var host = document.querySelector('.hv__icono-link--cuenta shopify-account');
        if (!host || !host.shadowRoot) return null;
        return (
          host.shadowRoot.querySelector('[part="signed-out-avatar"]') ||
          host.shadowRoot.querySelector('button')
        );
      }

      document.addEventListener('click', function (e) {
        try {
          var enlace = e.target && e.target.closest ? e.target.closest('[data-hv-cuenta-movil]') : null;
          if (!enlace) return;

          var btn = triggerCuenta();
          if (!btn) return;

          e.preventDefault();

          window.__veeryTrasCerrarMenu(function () {
            try { btn.click(); } catch (err) { window.location.href = enlace.href; }
          });
        } catch (err) {  }
      });
    } catch (e) {  }
  })();

  (function () {
    try {
      if (window.__veeryEnvioGratis) return;
      window.__veeryEnvioGratis = true;

      function formatear(centimos) {
        if (window.VeeryWishlist && typeof window.VeeryWishlist.formatMoney === 'function') {
          try { return window.VeeryWishlist.formatMoney(centimos); } catch (e) {}
        }
        var muestra = document.querySelector('.cart-drawer__dialog .cart-totals__total-value');
        var texto = muestra ? muestra.textContent.trim() : '';
        var simbolo = texto.replace(/[\d.,\s]/g, '') || '€';
        var valor = (centimos / 100).toFixed(2).replace('.', ',');
        return /^[^\d]/.test(texto) ? simbolo + valor : valor + ' ' + simbolo;
      }

      function actualizar(totalCentimos) {
        try {
          var caja = document.querySelector('[data-hv-envio]');
          if (!caja || typeof totalCentimos !== 'number') return;

          var umbral = parseInt(caja.getAttribute('data-umbral'), 10);
          if (!umbral || umbral <= 0) return;

          var falta = umbral - totalCentimos;
          var texto = caja.querySelector('[data-hv-envio-texto]');
          var relleno = caja.querySelector('[data-hv-envio-relleno]');

          if (texto) {
            var plantilla = caja.getAttribute('data-texto-falta') || '';
            texto.textContent =
              falta > 0
                ? (plantilla.indexOf('[amount]') !== -1
                    ? plantilla.replace('[amount]', formatear(falta))
                    : plantilla + ' ' + formatear(falta))
                : caja.getAttribute('data-texto-ok');
          }
          if (relleno) {
            var pct = (totalCentimos / umbral) * 100;
            relleno.style.width = (pct > 100 ? 100 : Math.round(pct)) + '%';
          }
        } catch (e) {  }
      }

      document.addEventListener('cart:update', function (e) {
        try {
          var d = e && e.detail && e.detail.resource;
          if (d && typeof d.total_price === 'number') actualizar(d.total_price);
        } catch (err) {  }
      });
    } catch (e) {  }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-obra-perdida"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function iniciar(root) {
      if (!root || root.__vop) return;
      root.__vop = true;

      var boton = root.querySelector('[data-vop-colgar]');
      var fuente = root.querySelector('[data-vop-obras]');
      if (!boton || !fuente) return;

      var obras = [];
      try { obras = JSON.parse(fuente.textContent) || []; } catch (e) { obras = []; }
      if (!obras.length) { boton.hidden = true; return; }

      var img = root.querySelector('[data-vop-obra]');
      var cartela = root.querySelector('[data-vop-cartela]');
      var nombre = root.querySelector('[data-vop-nombre]');
      var datos = root.querySelector('[data-vop-datos]');
      var ver = root.querySelector('[data-vop-ver]');
      var cola = [];
      var ultima = -1;

      function siguiente() {
        if (!cola.length) {
          for (var i = 0; i < obras.length; i++) cola.push(i);
          for (var j = cola.length - 1; j > 0; j--) {
            var k = Math.floor(Math.random() * (j + 1));
            var tmp = cola[j]; cola[j] = cola[k]; cola[k] = tmp;
          }
          if (cola.length > 1 && cola[0] === ultima) cola.push(cola.shift());
        }
        ultima = cola.shift();
        return obras[ultima];
      }

      function mostrar(o) {
        img.classList.remove('is-colgada');
        img.hidden = false;
        img.setAttribute('sizes', '(min-width: 750px) 360px, 66vw');
        img.setAttribute('srcset', o.srcset || '');
        img.src = o.src;
        img.alt = o.alt || o.t;
        if (o.w && o.h) { img.width = o.w; img.height = o.h; }
        void img.offsetWidth;
        img.classList.add('is-colgada');

        nombre.textContent = o.t;
        nombre.href = o.u;
        var lineas = [];
        if (o.a) lineas.push((root.getAttribute('data-por') || 'By') + ' ' + o.a);
        var fila = [o.s, o.p].filter(Boolean).join(' · ');
        if (fila) lineas.push(fila);
        datos.textContent = '';
        for (var i = 0; i < lineas.length; i++) {
          if (i) datos.appendChild(document.createElement('br'));
          datos.appendChild(document.createTextNode(lineas[i]));
        }
        cartela.hidden = false;
        if (ver) { ver.href = o.u; ver.hidden = false; }
        root.setAttribute('data-estado', 'obra');
        if (boton.getAttribute('data-otra')) boton.textContent = boton.getAttribute('data-otra');
      }

      boton.addEventListener('click', function () {
        var o = siguiente();
        var previa = new Image();
        previa.sizes = '(min-width: 750px) 360px, 66vw';
        if (o.srcset) previa.srcset = o.srcset;
        previa.src = o.src;
        var hecho = false;
        function listo() { if (hecho) return; hecho = true; mostrar(o); }
        if (previa.decode) previa.decode().then(listo, listo); else listo();
        setTimeout(listo, 1500);
      });
    }

    function todas() {
      var raices = document.querySelectorAll('[data-vop]');
      for (var i = 0; i < raices.length; i++) iniciar(raices[i]);
    }
    todas();
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-recomendaciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.__vrecVigilante) return;
    window.__vrecVigilante = true;

    function vigilar(pista) {
      if (pista.__vrecVigilada || !('MutationObserver' in window)) return;
      pista.__vrecVigilada = true;
      new MutationObserver(function () {
        if (pista.children.length) document.dispatchEvent(new CustomEvent('veery:wishlist:change'));
      }).observe(pista, { childList: true });
    }

    function iniciar(contexto) {
      var pistas = (contexto || document).querySelectorAll('.vrec [data-vcar-pista]');
      for (var i = 0; i < pistas.length; i++) vigilar(pistas[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciar(document); });
    } else {
      iniciar(document);
    }
    document.addEventListener('shopify:section:load', function (e) { if (e.target) iniciar(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-room-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__veeryRoomPuntos) return;
    window.__veeryRoomPuntos = true;

    function fichaDe(boton) {
      var id = boton.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function cerrarTodo() {
      var abiertos = document.querySelectorAll('[data-rec-punto][aria-expanded="true"]');
      for (var i = 0; i < abiertos.length; i++) {
        abiertos[i].setAttribute('aria-expanded', 'false');
        var f = fichaDe(abiertos[i]);
        if (f) f.hidden = true;
      }
    }

    document.addEventListener('click', function (e) {
      var destino = e.target;
      if (!destino || !destino.closest) return;
      var boton = destino.closest('[data-rec-punto]');
      if (boton) {
        e.preventDefault();
        var abierto = boton.getAttribute('aria-expanded') === 'true';
        cerrarTodo();
        if (!abierto) {
          var ficha = fichaDe(boton);
          if (ficha) {
            boton.setAttribute('aria-expanded', 'true');
            ficha.hidden = false;
          }
        }
        return;
      }
      if (!destino.closest('[data-rec-ficha]')) cerrarTodo();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var abierto = document.querySelector('[data-rec-punto][aria-expanded="true"]');
      if (!abierto) return;
      cerrarTodo();
      abierto.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veery-the-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PATRON = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function iniciar(raiz) {
      if (!raiz || raiz.__vtlListo) return;
      raiz.__vtlListo = true;

      var form = raiz.querySelector('[data-vtl-form]');
      if (!form) return;
      var input = form.querySelector('[data-vtl-input]');
      var boton = form.querySelector('[data-vtl-boton]');
      var error = form.querySelector('[data-vtl-error]');
      var cuerpo = form.querySelector('[data-vtl-cuerpo]');
      var ok = form.querySelector('[data-vtl-ok]');
      var okTitulo = form.querySelector('[data-vtl-ok-titulo]');
      var otra = form.querySelector('[data-vtl-otra]');
      var enviando = false;

      function ponerError(texto) {
        error.textContent = texto;
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', error.id);
        input.focus();
      }
      function limpiarError() {
        if (!input.hasAttribute('aria-invalid')) return;
        error.textContent = '';
        input.removeAttribute('aria-invalid');
        input.setAttribute('aria-describedby', raiz.id + '-legal');
      }
      function exito() {
        cuerpo.classList.add('vtl__oculto');
        ok.classList.remove('vtl__oculto');
        raiz.classList.add('vtl--apuntado');
        if (okTitulo) okTitulo.focus({ preventScroll: true });
      }
      function reiniciar() {
        ok.classList.add('vtl__oculto');
        cuerpo.classList.remove('vtl__oculto');
        raiz.classList.remove('vtl--apuntado');
        input.value = '';
        limpiarError();
        input.focus({ preventScroll: true });
      }
      function ocupado(si) {
        enviando = si;
        if (si) {
          boton.setAttribute('aria-busy', 'true');
          boton.setAttribute('data-texto', boton.innerHTML);
          boton.textContent = raiz.getAttribute('data-vtl-enviando') || 'Joining…';
        } else {
          boton.removeAttribute('aria-busy');
          if (boton.hasAttribute('data-texto')) boton.innerHTML = boton.getAttribute('data-texto');
        }
      }
      function envioNativo() {
        ocupado(false);
        HTMLFormElement.prototype.submit.call(form);
      }

      input.addEventListener('input', limpiarError);
      if (otra) otra.addEventListener('click', reiniciar);

      form.addEventListener('submit', function (evento) {
        var valor = input.value.trim();
        if (!valor) { evento.preventDefault(); ponerError(raiz.getAttribute('data-vtl-vacio')); return; }
        if (!PATRON.test(valor)) { evento.preventDefault(); ponerError(raiz.getAttribute('data-vtl-invalido')); return; }
        if (!window.fetch || !window.DOMParser) return;
        evento.preventDefault();
        if (enviando) return;
        ocupado(true);

        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (respuesta) {
            if (/\/challenge/.test(respuesta.url)) { envioNativo(); return null; }
            return respuesta.text().then(function (html) { return { url: respuesta.url, html: html }; });
          })
          .then(function (r) {
            if (!r) return;
            if (/customer_posted=true/.test(r.url)) { ocupado(false); exito(); return; }
            var doc = new DOMParser().parseFromString(r.html, 'text/html');
            var misma = doc.getElementById(raiz.id);
            var marca = misma && misma.querySelector('[data-vtl-estado]');
            var estado = marca ? marca.getAttribute('data-vtl-estado') : '';
            if (estado === 'ok') { ocupado(false); exito(); return; }
            if (estado === 'error') {
              ocupado(false);
              var msj = misma.querySelector('[data-vtl-error]');
              ponerError((msj && msj.textContent.trim()) || raiz.getAttribute('data-vtl-fallo'));
              return;
            }
            envioNativo();
          })
          .catch(envioNativo);
      });
    }

    function escanear(contexto) {
      (contexto || document).querySelectorAll('[data-vtl]').forEach(iniciar);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { escanear(); });
    else escanear();
    document.addEventListener('shopify:section:load', function (e) { escanear(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
